import { AuctionInsightKey } from '~/src/dash/apiV2/auctionInsights';
import { ISankeyNodeConfig } from '~/src/dash/components/charts/Sankey/common';
import { graphColors } from '~/src/dash/utils/colors';

export const campaignAuctionInsightsNodes: Partial<Record<AuctionInsightKey, ISankeyNodeConfig>> = {
  TotalAdserverInventoryRequest: {
    tKey: 'RawRequests',
    color: graphColors.lightblue,
    order: 1,
    depth: 0, // Start
  },
  TotalAdserverRequest: {
    tKey: 'PacedRequests',
    color: graphColors.blue,
    order: 2,
    depth: 1,
  },
  TotalPacingRejected: {
    tKey: 'PacingRejected',
    color: graphColors.lavender,
    order: 3,
    depth: 1,
    isTerminal: true,
  },
  TotalBidResponse: {
    tKey: 'BidResponses',
    color: graphColors.turquoise,
    order: 4,
    depth: 2,
  },
  TotalInvalidCreatives: {
    tKey: 'InvalidCreatives',
    color: graphColors.blueGrey,
    order: 5,
    depth: 2,
    isTerminal: true,
  },
  TotalNoBid: {
    tKey: 'NoBids',
    color: graphColors.paleYellow,
    order: 6,
    depth: 2,
    isTerminal: true,
  },
  TotalBidTimeout: {
    tKey: 'BidTimeouts',
    color: graphColors.slateGrey,
    order: 7,
    depth: 2,
    isTerminal: true,
  },
  TotalConnectionErrors: {
    tKey: 'ConnectionErrors',
    color: graphColors.redOrange,
    order: 8,
    depth: 2,
    isTerminal: true,
  },
  TotalInvalidBids: {
    tKey: 'InvalidBids',
    color: graphColors.sienna,
    order: 9,
    depth: 2,
    isTerminal: true,
  },
  TotalValidBids: {
    tKey: 'ValidBids',
    color: graphColors.pink,
    order: 10,
    depth: 3,
  },
  TotalBidResponseErrors: {
    tKey: 'BidResponseErrors',
    color: graphColors.palePink,
    order: 11,
    depth: 3,
    isTerminal: true,
  },
  TotalUnwrapErrors: {
    tKey: 'UnwrapErrors',
    color: graphColors.purpleBlue,
    order: 12,
    depth: 3,
    isTerminal: true,
  },
  TotalBidWon: {
    tKey: 'BidWon',
    color: graphColors.seaGreen,
    order: 13,
    depth: 4,
  },
  TotalBidLost: {
    tKey: 'BidLost',
    color: graphColors.coralPink,
    order: 14,
    depth: 4,
    isTerminal: true,
  },
  TotalValidBidsRejected: {
    tKey: 'BidRejected',
    color: graphColors.limeGreen,
    order: 15,
    depth: 4,
    isTerminal: true,
  },
  TotalBidderImpression: {
    tKey: 'Impressions',
    color: graphColors.lightOrange,
    order: 16,
    depth: 5,
    isTerminal: true,
  },
  TotalBidderNoImpression: {
    tKey: 'NoImpressions',
    color: graphColors.fluorescentPink,
    order: 17,
    depth: 5,
    isTerminal: true,
  },
};
